// extracted by mini-css-extract-plugin
module.exports = {"Page":"Glossary_Page__3Q2Fa","Section":"Glossary_Section__3dcmI","Definition":"Glossary_Definition__37r_4"};